import type { LastMonthExpenseDTO } from "../models/lastMonthExpenseDto";
import type { LastMonthExpenseEntity } from "../../domain/entities/LastMonthExpenseEntity";

export function lastMonthExpenseDtoToEntity(
  dto: LastMonthExpenseDTO
): LastMonthExpenseEntity {
  return {
    monthLabel: dto.monthLabel ?? "",
    status: dto.status ?? "medium",
    expense: Number(dto.expense) || 0,
    revenue: Number(dto.revenue) || 0,
    momPercent: dto.momPercent != null ? Number(dto.momPercent) : null,
    avgExpense: Number(dto.avgExpense) || 0,
		revenuePercent:
			dto.revenuePercent != null ? Number(dto.revenuePercent) : null,
    barMonths: (dto.barMonths ?? []).map((m) => ({
      year: Number(m.year),
      month: Number(m.month),
      label: String(m.label ?? ""),
      expense: Number(m.expense) || 0,
    })),
  };
}
